"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LRUCache = void 0;
function LRUCache(maxSizeIncl) {
    if (maxSizeIncl < 1) {
        throw new Error(`LRUCache: maxSizeIncl must be at least 1`);
    }
    let tail = null;
    let head = tail;
    const map = new Map();
    let size = 0;
    function addMany(values) {
        values.forEach(add);
    }
    function add(value) {
        if (size >= maxSizeIncl) {
            removeByValueOrLRUPolicy(value);
            size--;
        }
        if (map.has(value)) {
            removeByValueOrLRUPolicy(value);
            size--;
        }
        const newNodeReference = { prev: null, value, next: null };
        if (head === null) {
            head = newNodeReference;
            tail = head;
        }
        else {
            newNodeReference.prev = head;
            head.next = newNodeReference;
            head = head.next;
        }
        size++;
        map.set(value, newNodeReference);
    }
    function removeByValueOrLRUPolicy(value) {
        let nodeReference;
        if (!map.has(value)) {
            nodeReference = tail;
        }
        else {
            nodeReference = map.get(value);
        }
        if (nodeReference === undefined || nodeReference === null) {
            throw new Error(`LRUCache: nodeReference cannot be undefined (or null?) when deleting`);
        }
        const prevNodeRef = nodeReference.prev;
        const nextNodeRef = nodeReference.next;
        map.delete(value);
        if (prevNodeRef === null && nextNodeRef === null) {
            tail = null;
            head = null;
        }
        else if (prevNodeRef === null) {
            tail = nextNodeRef;
            nextNodeRef.prev = null;
        }
        else if (nextNodeRef === null) {
            head = prevNodeRef;
            prevNodeRef.next = null;
        }
        else {
            prevNodeRef.next = nextNodeRef;
            nextNodeRef.prev = prevNodeRef;
        }
    }
    const getAllWithCacheFactory = (newestOrOldest) => {
        let cacheKey;
        let cache = [];
        const isCacheHit = () => cacheKey === head;
        return () => {
            if (isCacheHit()) {
                return cache;
            }
            const values = [];
            let [initialNode, nextOrPreviousAccessor] = {
                newest: [head, "prev"],
                oldest: [tail, "next"],
            }[newestOrOldest];
            while (initialNode !== null) {
                values.push(initialNode.value);
                initialNode = initialNode[nextOrPreviousAccessor];
            }
            cacheKey = head;
            cache = values;
            return values;
        };
    };
    const getAllOldToNew = getAllWithCacheFactory("oldest");
    const getAllNewToOld = getAllWithCacheFactory("newest");
    const getTail = () => tail;
    const getHead = () => head;
    const getSize = () => size;
    const getMaxSize = () => maxSizeIncl;
    return {
        add,
        addMany,
        getAllOldToNew,
        getAllNewToOld,
        getTail,
        getHead,
        get: () => ({
            getAllOldToNew: getAllOldToNew(),
            getAllNewToOld: getAllNewToOld(),
            getTail: getTail(),
            getHead: getHead(),
            getSize: getSize(),
            getMaxSize: getMaxSize(),
        }),
    };
}
exports.LRUCache = LRUCache;
//# sourceMappingURL=LRUCache.js.map